import React, {useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import {socket, socketUseEffect} from "../../socket";
import PageTitle from "../core/page-title";
import {useAuth} from "../../AuthContext";

const ChooseDashboard = (props) => {
    const [details, setDetails] = useState(false)
    const { object } = useParams();

    const navigate = useNavigate();

    const { user } = useAuth();

    /*useEffect(() => {
            /*if(details !== false){
                console.log("details", details)
                navigate(`/${object}/1/dashboard`);
            }else{
                socketUseEffect(listeners, user)
            }

        }, [object, details]);*/

    useEffect(() => {

        socket.on(`${object}:get-items-list-data`, (data) => {
            //console.log("Loaded data :::", data)
            if(data.data.length === 0){
                navigate(`/${object}`);
            }else{
                let redirect = ""
                switch(object){
                    case 'servers':
                        redirect = 'server';
                        break
                }

                navigate(`/${redirect}/${data.data[0].id}/dashboard`);
            }
        });

        //refresh &&
        getItems("name")

        return () => {
            socket.off(`${object}:get-items-list-data`)
        };
    },[]);

    const getItems = (column) => {
        var data = {
            token: user.token,
            simple_search_text: "",
            order_by: column,
            order_rule: "asc",
        };

        socket.emit(`${object}:get-items-list`, data);
    }

    return (
        <>
            <PageTitle
                title={"Loading..."}
                homeUrl={"/dashboard"} subTitle={"Details"}
                links={[]}
            />

            <h1>Loading dashboard... </h1>
        </>
    );
};

export default ChooseDashboard;
